const context = require.context('CustomModules/GlobalBPOCore/assets/country_flags', true, /.png$/)

const FLAGS = {}
context.keys().forEach((key) => {
  const countryCode = key.split('./').pop() // remove the first 2 characters
    .substring(0, key.length - 6) // remove the file extension
  FLAGS[countryCode.toUpperCase()] = context(key)
})

export default FLAGS



// WEBPACK FOOTER //
// ./src/customization/GlobalBPOCore/Util/FlagsUtil.js